/* eslint-disable @typescript-eslint/no-explicit-any */
import * as Sentry from "@sentry/react-native";
import { config } from "../config";
import appConfig from "../../app.config";

export const errorReporting = {
  initialize: async () => {
    Sentry.init({
      dsn: "https://e4db68889ee5adc297e175b3601922fc@o379212.ingest.us.sentry.io/4506863869165568",
      debug: config.isDevelopment,
      enabled: !config.isDevelopment,
      release: appConfig.version,
      ignoreErrors: [
        // network errors
        "Network request failed",
        "Network Error",
        "request timed out",
        "Connection reset",
        "connection could not be established",
        "network connection was lost",
        "connection closed",
        "timeout of 15000ms",
        // playback errors
        "AbortError: The play() request was interrupted",
        "NotAllowedError: play() failed because the user didn't interact with the document first",
        // Wake lock errors
        "Wake Lock permission request denied",
        "Access to Screen Wake Lock",
        "screen-wake-lock",
      ],
    });

    Sentry.setTag("app_version", appConfig.version);
  },
  setDeviceId: (id: string) => {
    Sentry.setTag("device_id", id);
  },
  sendError: (error: Error) => {
    if (config.isDevelopment) {
      console.error(error);
    } else {
      Sentry.captureException(error);
    }
  },
  sendMessage: (message: string, data?: object) => {
    if (config.isDevelopment) {
      console.warn(message, data);
    } else {
      Sentry.withScope((scope) => {
        scope.setExtra("data", data);
        Sentry.captureException(new Error(message));
      });
    }
  },
  ignoreLogs: (ignoreLogs: string[]) => {
    if (!__DEV__) return;
    console.log = filterIgnoredMessages(ignoreLogs, console.log);
    console.info = filterIgnoredMessages(ignoreLogs, console.info);
    console.warn = filterIgnoredMessages(ignoreLogs, console.warn);
    console.error = filterIgnoredMessages(ignoreLogs, console.error);
  },
};

const filterIgnoredMessages =
  (ignoreLogs: string[], logger: any): ((...args: any[]) => void) =>
  (...args): void => {
    const output = args
      .slice(1)
      .reduce(
        (baseString, currentString) => baseString.replace("%s", currentString),
        args[0],
      );

    if (
      !ignoreLogs.some(
        (log) => typeof output === "string" && output.includes(log),
      )
    ) {
      logger(...args);
    }
  };
